import { OnInit } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
var Formulario41Component = /** @class */ (function () {
    function Formulario41Component() {
        this.htmlcanvas = html2canvas;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.region = GLOBAL.region;
        //contadores
        this.sup_proy_total = 0;
        this.cant = 0;
        this.sup_porcentajes = 0;
        this.pages = [1, 2, 3];
        //CARACTERISTICAS DEL ANTEPROYECTO DE LOTEO
        if (JSON.parse(localStorage.getItem("caract_anteproy_loteo"))) {
            if (JSON.parse(localStorage.getItem("caract_anteproy_loteo")).length > 0) {
                this.caract_anteproy_loteo = JSON.parse(localStorage.getItem("caract_anteproy_loteo"));
            }
            else {
                localStorage.setItem("caract_anteproy_loteo", JSON.stringify([]));
                this.caract_anteproy_loteo = [{ sup_ant_loteo: '', num_anteproy_act: '', sup_anteproy_act: '', hoja_anexa_loteo: '' }];
            }
        }
        //PORCENTAJES ANTEPROYECTO
        if (JSON.parse(localStorage.getItem("porcentajes_anteproy"))) {
            if (JSON.parse(localStorage.getItem("porcentajes_anteproy")).length > 0) {
                this.porcentajes_anteproy = JSON.parse(localStorage.getItem("porcentajes_anteproy"));
            }
            else {
                localStorage.setItem("porcentajes_anteproy", JSON.stringify([]));
                this.porcentajes_anteproy = [{ sup_predios: '', porc_predios: '', cant_predios: '', sup_areas: '', porc_areas: '', cant_areas: '', sup_equip: '', porc_equip: '', cant_equip: '', sup_valid: '', porc_valid: '', cant_valid: '', sup_reserva: '', porc_reserva: '', cant_reserva: '' }];
            }
        }
    }
    Formulario41Component.prototype.ngOnInit = function () {
    };
    Formulario41Component.prototype.ngAfterContentChecked = function () {
        this.ngAfterContentInit();
    };
    Formulario41Component.prototype.ngDoCheck = function () {
        this.cant = 0;
        this.sup_porcentajes = 0;
        this.sup_proy_total = 0;
        this.sup_porcentajes = parseInt(this.porcentajes_anteproy[0].sup_predios) + parseInt(this.porcentajes_anteproy[0].sup_areas) + parseInt(this.porcentajes_anteproy[0].sup_valid);
        this.cant = parseInt(this.porcentajes_anteproy[0].cant_predios) + parseInt(this.porcentajes_anteproy[0].cant_areas) + parseInt(this.porcentajes_anteproy[0].cant_valid);
        for (var i = 0; i < this.caract_anteproy_loteo.length; i++) {
            this.sup_proy_total = this.sup_proy_total + parseInt(this.caract_anteproy_loteo[i].sup_anteproy_act);
        }
    };
    Formulario41Component.prototype.ngAfterContentInit = function () {
        //PROPIEDAD
        if (JSON.parse(localStorage.getItem("cip"))) {
            if (JSON.parse(localStorage.getItem("cip")).length > 0) {
                this.cip = JSON.parse(localStorage.getItem("cip"));
            }
            else {
                localStorage.setItem("cip", JSON.stringify([]));
                this.cip = [{ certcip: '', fecha_cip: '' }];
            }
        }
        //PROPIEDAD
        if (JSON.parse(localStorage.getItem("propiedad"))) {
            if (JSON.parse(localStorage.getItem("propiedad")).length > 0) {
                this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
            }
            else {
                localStorage.setItem("propiedad", JSON.stringify([]));
                this.propiedad = [{ rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa: '', direc_complemento: '', direc_compl_num: '', loteo: '', manzana: '', plano: '', recordId: '' }];
            }
        }
        //PROPIETARIOS
        if (JSON.parse(localStorage.getItem("propietarios"))) {
            if (JSON.parse(localStorage.getItem("propietarios")).length > 0) {
                this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
            }
            else {
                localStorage.setItem("propietarios", JSON.stringify([]));
                this.propietarios = [{ rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', recordId: '' }];
            }
        }
        //PERMISO NOTARIADO
        if (JSON.parse(localStorage.getItem("permiso_notariado"))) {
            if (JSON.parse(localStorage.getItem("permiso_notariado")).length > 0) {
                this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
            }
            else {
                localStorage.setItem("permiso_notariado", JSON.stringify([]));
                this.permiso_notariado = [{ acreditacion: '', fecha: null, escritura: null, notario: '' }];
            }
        }
        //ARQUITECTOS
        if (JSON.parse(localStorage.getItem("arquitectos"))) {
            if (JSON.parse(localStorage.getItem("arquitectos")).length > 0) {
                this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"));
            }
            else {
                localStorage.setItem("arquitectos", JSON.stringify([]));
                this.arquitectos = [{ rut: '', nombre: '', mail: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_complemento: '', direccion_num: '', comuna: '', fono: '', fax: '', patente: '', recordId: '' }];
            }
        }
        //REGISTRO DE BIENES
        if (JSON.parse(localStorage.getItem("registro_bienes"))) {
            if (JSON.parse(localStorage.getItem("registro_bienes")).length > 0) {
                this.registro_bienes = JSON.parse(localStorage.getItem("registro_bienes"));
            }
            else {
                localStorage.setItem("registro_bienes", JSON.stringify([]));
                this.registro_bienes = [{ inscrito: '', numero: '', anio: '', bienes: '' }];
            }
        }
        //DECLARACION
        if (JSON.parse(localStorage.getItem("declaracion"))) {
            if (JSON.parse(localStorage.getItem("declaracion")).length > 0) {
                this.declaracion = JSON.parse(localStorage.getItem("declaracion"));
            }
            else {
                localStorage.setItem("declaracion", JSON.stringify([]));
                this.declaracion = [{ inscrito: '', numero: '', anio: '', bienes: '' }];
            }
        }
        //PORCENTAJES ANTEPROYECTO
        if (JSON.parse(localStorage.getItem("porcentajes_anteproy"))) {
            if (JSON.parse(localStorage.getItem("porcentajes_anteproy")).length > 0) {
                this.porcentajes_anteproy = JSON.parse(localStorage.getItem("porcentajes_anteproy"));
            }
            else {
                localStorage.setItem("porcentajes_anteproy", JSON.stringify([]));
                this.porcentajes_anteproy = [{ sup_predios: '', porc_predios: '', cant_predios: '', sup_areas: '', porc_areas: '', cant_areas: '', sup_equip: '', porc_equip: '', cant_equip: '', sup_valid: '', porc_valid: '', cant_valid: '', sup_reserva: '', porc_reserva: '', cant_reserva: '' }];
            }
        }
        //CARACTERISTICAS DEL ANTEPROYECTO DE LOTEO
        if (JSON.parse(localStorage.getItem("caract_anteproy_loteo"))) {
            if (JSON.parse(localStorage.getItem("caract_anteproy_loteo")).length > 0) {
                this.caract_anteproy_loteo = JSON.parse(localStorage.getItem("caract_anteproy_loteo"));
            }
            else {
                localStorage.setItem("caract_anteproy_loteo", JSON.stringify([]));
                this.caract_anteproy_loteo = [{ sup_ant_loteo: '', num_anteproy_act: '', sup_anteproy_act: '', hoja_anexa_loteo: '' }];
            }
        }
    };
    Formulario41Component.prototype.captureScreen = function () {
        var _this = this;
        var pdf = new jspdf('p', 'mm', 'a4');
        this.htmlcanvas(document.getElementById("page1")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page2")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        this.htmlcanvas(document.getElementById("page3")).then(function (canvas) {
            var contentDataURL = canvas.toDataURL('image/png');
            pdf.addPage();
            pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297);
        });
        setTimeout(function () {
            pdf.save(_this.propietarios[0].rut + '.pdf');
            // pdf.save('prueba.pdf')
        }, 6000);
    };
    return Formulario41Component;
}());
export { Formulario41Component };
